/**
 * Texto que a cláusula de cancelamento já traz preenchida no formulário do
 * fornecedor.
 *
 * Os XX e o X% ficam como lacuna de propósito: a condição é negociada caso a
 * caso, e o modelo serve para o fornecedor não precisar redigir a cláusula do
 * zero — nem deixá-la em branco por não saber o que escrever.
 */
export const CLAUSULA_CANCELAMENTO_PADRAO =
  "Em caso de cancelamento com menos de XX dias, será cobrado X% do valor deste orçamento.";
